
import React, { useContext } from 'react'
import {
  setDevelopperView, setViewFinanceFile,
  setNetworkZone,  setViewTestCalculator, setProcess, setAmountNature,
  setVehicle, setVehiclesConfig, setVehiclesStock, setSettingLanguage, setPerimeterFilter,
  setWidgetType,setZIndex,
  setFinanceFileResource
} from '../actions/actionsAppTest'
import { fetchSimulationVehicleDetailsIfNeeded, fetchSimulationVehiclesIfNeeded } from '../actions/actionsApiSimulation';
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import TestSetting from '../components/setting/TestSetting'
import HelperVehicle from '../helpers/HelperVehicle';

export default function ContTestSetting() {

  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onChangeDevelopperView(checked) {
    dispatch(setDevelopperView(checked));
  }

  function onChangeFinanceFile(value) {
    dispatch(setViewFinanceFile(value));
  }
  function onChangeNetworkZone(value) {
    dispatch(setNetworkZone(value))
  }
  function onChangeFinanceFileResource(value) {
    dispatch(setFinanceFileResource(value))
  }
  function onChangePerimeterFilter(value, vehDescType) {
    dispatch(setPerimeterFilter(value, vehDescType))
  }
  function onChangeWidgetType(value) {
    dispatch(setWidgetType(value))
  }
  function onChangeZIndex(value) {
    dispatch(setZIndex(value))
  }
  function onChangeAmountNature(value) {
    dispatch(setAmountNature(value))
  }
  function onChangeTestCalculator(value) {
    dispatch(setViewTestCalculator(value))
  }
  function onChangeProcess(value) {
    dispatch(setProcess(value))
  }
  function onChangeLanguage(language, contextLanguage) {
    dispatch(setSettingLanguage(language, contextLanguage));
  }
  function onChangeVehicleExample(value) {
    fetchSimulationVehicleDetailsIfNeeded(globalstate, dispatch, { vehicle: value }, null, false);
    dispatch(setVehicle(value))
  }
  function onLoadVehicleExamples(vehicles, process) {
    if (process === 'vehiclesStock' || process === 'vehiclesDefault') {
      for (const i in vehicles) {
        vehicles[i].configurationKey = HelperVehicle.buidVehicleConfigurationKey(i);
      }
      fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, { vehiclesStock: vehicles }, null, null, false);
      dispatch(setVehiclesStock(vehicles));
    } else {
      for (const j in vehicles) {
        vehicles[j].options = null;
        vehicles[j].accessories = null;
        vehicles[j].configurationKey = HelperVehicle.buidVehicleConfigurationKey(j);
      }
      fetchSimulationVehiclesIfNeeded(globalstate, dispatch, {}, { vehiclesConfig: vehicles }, null, null, false);
      dispatch(setVehiclesConfig(vehicles));
    }
  }

  return (
    <TestSetting
      context={globalstate.testCriteria.context}
      settings={globalstate.settings}
      env={globalstate.env}
      onChangeDevelopperView={onChangeDevelopperView}
      onChangeFinanceFile={onChangeFinanceFile}
      onChangeNetworkZone={onChangeNetworkZone}
      onChangeFinanceFileResource={onChangeFinanceFileResource}
      onChangePerimeterFilter={onChangePerimeterFilter}
      onChangeWidgetType={onChangeWidgetType}
      onChangeAmountNature={onChangeAmountNature}
      onChangeTestCalculator={onChangeTestCalculator}
      onChangeProcess={onChangeProcess}
      onChangeLanguage={onChangeLanguage}
      onChangeVehicleExample={onChangeVehicleExample}
      onLoadVehicleExamples={onLoadVehicleExamples}
      onChangeZIndex={onChangeZIndex}
    />
  );

}
